
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class GeneralSetupService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    getApprovalStatus() {
        return this.http.get(`setup/approval-status`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllSectors() {
        return this.http.get(`setups/sectors`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getApprovedEmployers() {
        return this.http.get(`setup/get-all-approved-employers`)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => observableThrowError(error.error || 'Server error')),);
        }

    getAllOperations() {
        return this.http.get(`setups/operation`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getAllSubSectors() {
        return this.http.get(`setups/subsectors`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCustomerSectorBySubSectorId(subSectorId) {
        return this.http.get(`setups/subsector/${subSectorId}/sectors`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    //EMPLOYER SERVICE
    getEmployersList() {
        return this.http.get(`setup/employers`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getEmployerDetail(employerId) {
        return this.http.get(`setup/employer/${employerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getEmployerType() {
        return this.http.get(`setup/employer-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    addEmployerType(data) {
        return this.http.post(`setup/add-employer-type`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    addEmployerSubType(data) {
        return this.http.post(`setup/add-employer-sub-type`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    updateEmployerType(employerTypeId,data) {
        return this.http.put(`setup/update-employer-type/${employerTypeId}`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    updateEmployerSubType(employerSubTypeId,data) {
        return this.http.put(`setup/update-employer-sub-type/${employerSubTypeId}`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getAllEmployerSubType() {
        return this.http.get(`setup/all-employer-sub-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getEmployerSubType(EmployerTypeId) {
        return this.http.get(`setup/employer-sub-type/${EmployerTypeId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addEmployer(formObj) {
        const bodyObj = JSON.stringify(formObj);
        return this.http.post(`setup/add-employer`, bodyObj).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    UpdateEmployer(employerId,formObj) {
        const bodyObj = JSON.stringify(formObj);
        return this.http.put(`setup/update-employer/${employerId}`, bodyObj).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    deleteEmployert(employerId) {      
        return this.http.delete(`setup/delete-employer/${employerId}`).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    //PRUDENTIAL GUIDELINE SERVICES
    getPrudentialGuidelineList() {
        return this.http.get(`setup/get-prudential-guidelines`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getPrudentialGuidelineDetail(prudentialGuidelineId) {
        return this.http.get(`setup/get-prudential-guideline/${prudentialGuidelineId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    addPrudentialGuideline(formObj) {
        const bodyObj = JSON.stringify(formObj);
        return this.http.post(`setup/add-prudential-guideline`, bodyObj).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    UpdatePrudentialGuideline(prudentialGuidelineId,formObj) {
        const bodyObj = JSON.stringify(formObj);
        return this.http.put(`setup/update-prudential-guideline/${prudentialGuidelineId}`, bodyObj).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    deletePrudentialGuideline(prudentialGuidelineId) {      
        return this.http.delete(`setup/delete-prudential-guideline/${prudentialGuidelineId}`).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getPrudentialType() {
        return this.http.get(`setup/get-prudential-guidelines-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    ///Limit and Monitoring
    getAlertList() {
        return this.http.get(`setup/monitoring-alert-messages`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    UpdateEmailAlertMessages(prudentialGuidelineId,formObj) {
        const bodyObj = JSON.stringify(formObj);
        return this.http.put(`setup/update-email-lert-message`, bodyObj).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getEmailMessagesList() {
        return this.http.get(`setup/limit-and-monitoring`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getEmailMessagesDetail(alertId) {
        return this.http.get(`setup/limit-and-monitoring/${alertId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    addEmailMessages(formObj) {
        const bodyObj = JSON.stringify(formObj);
        return this.http.post(`setup/add-limit-and-monitoring`, bodyObj).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    UpdateEmailMessages(prudentialGuidelineId,formObj) {
        const bodyObj = JSON.stringify(formObj);
        return this.http.put(`setup/update-limit-and-monitoring`, bodyObj).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    deleteEmailMessages(bodyObj) {      
        return this.http.delete(`setup/delete-limit-and-monitoring`).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getProfileBusinessUnits() {
        return this.http.get(`setups/profile-business-unit`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCallMemoWaitingForApproval() {
        return this.http.get(`credit/get-call-memo-waiting-for-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getSignatoryById(id) {
        return this.http.get(`setups/signatory/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllSignatories() {
        return this.http.get(`setups/signatory`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateSignatory(id, body) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/signatory/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    

    saveSignatory(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/signatory`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

  

    removeSignatory(id) {
        return this.http.delete(`setups/signatory/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllInsuranceCompanies() {
        return this.http.get(`credit/insurance`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveInsuranceCompany(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/insurance`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateInsuranceCompany(id, body) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/insurance/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteInsuranceCompany(id) {      
        return this.http.delete(`credit/insurance/${id}`).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllInsuranceTypes() {
        return this.http.get(`credit/insurance-type-all`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveInsuranceType(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/insurance-type`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateInsuranceType(id, body) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/insurance-type/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteInsuranceType(id) {      
        return this.http.delete(`credit/insurance-type/${id}`).pipe(     
           map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


}